import {ApolloLink} from '@apollo/client/core';
import {from, throwError} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';

/** An authorizer's 401, whether it arrives as Angular's HttpErrorResponse or as Apollo's ServerError. */
export function isUnauthorized(error: any): boolean {
  return error?.status === 401 || error?.statusCode === 401;
}

/**
 * A token can still be refused — it expired in flight, or the session behind it ended. Refresh once and
 * retry the operation; if even the refresh fails, the login is gone, so `signIn()` and pass the error on.
 * Put it in front of the link that sets the Authorization header, so the retry picks up the new token.
 */
export function retryAfterRefreshLink(refresh: () => Promise<boolean>, signIn: () => void): ApolloLink {
  return new ApolloLink((operation, forward) => forward(operation).pipe(catchError(error => {
    if (!isUnauthorized(error) || operation.getContext()['retriedAfterRefresh']) {
      return throwError(() => error);
    }
    operation.setContext({retriedAfterRefresh: true});
    return from(refresh()).pipe(mergeMap(refreshed => {
      if (!refreshed) {
        signIn();
        return throwError(() => error);
      }
      return forward(operation);
    }));
  })));
}
